module.exports = __webpack_public_path__ + "img/java.64dad7e8.png";